import { Autocomplete, Button, TextField } from "@mui/material";
import styles from "../Settings/AppVersion.module.css";
import { getAutocompleteStyles } from "../../style/getAutoCompleteStyles";
import { useLazyQuery } from "@apollo/client";
import { GET_ACTIVE_USERS, GET_LEAGUES } from "./api/addTicketsQuery";
import { useEffect, useState } from "react";
import ToasterWithMessage from "../../components/shared-components/toaster";
import addTicketStyles from "./AddTickets.module.css";
import { AddTicketsInput } from "./AddTickets";

interface UsersList {
    u_id: string,
    u_email_id: string
}

interface LeagueList {
    l_id: string;
    l_name: string;
    l_type?: string|null;

}

const AddTicketsUsersAndLeagues = ({setPage, ticketDetails, setTicketDetails, page}: AddTicketsInput) => {
    const [listOfUsers, setListOfUsers] = useState([]);
    const [searchText, setSearchText] = useState<UsersList | null>(null);
    const [listOfLeagues, setListOfLeagues] = useState([]);
    const [searchLeagues, setSearchLeagues] = useState<LeagueList | null>(null);
    const [nextBtnClicked, setNextButtonClicked] = useState(false);
    const { error } = ToasterWithMessage();

    const [getUsers, { loading }] = useLazyQuery(GET_ACTIVE_USERS, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            setListOfUsers(data?.user);
        },
        onError: (err) => {
            console.log(err, "ERROR WHILE GETTING LIST OF USERS");
            error(err?.message);
        }
    });

    const [getListOfLeagues, { loading: leaguesLoading }] = useLazyQuery(GET_LEAGUES, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            setListOfLeagues(data?.leagues);
        },
        onError: (err) => {
            console.log(err, "====LIST OF LEAGUES ERROR");
            error(err?.message);
        }
    })
    const handleSearchUsers = (event: any, value: any) => {
        setSearchText(value);
        setTicketDetails({
            ...ticketDetails,
            userId: value?.u_id,
            userEmail: value?.u_email_id
        });
    }

    const handleInput = async (_event: any, value: any) => {
        if (value.length >= 3) {
            await getUsers({
                variables: {
                    searchText: `${value}%`
                }
            })
        }
    }

    const handleSearchLeagues = (_event: any, value: LeagueList | null) => {
        setSearchLeagues(value);
        setTicketDetails({
            ...ticketDetails,
            leagueId: value?.l_id,
            leagueName: value?.l_name,
            leagueType:value?.l_type 
        })
    }

    const handleUsersAndLeaguesNext = () => {
        setNextButtonClicked(true);
        if(searchText && searchLeagues) {
            setPage(1);
        }
    }

    useEffect(() => {
        getListOfLeagues();
    }, []);

    useEffect(() => {
        if(ticketDetails) {
            setSearchText({
                u_id: ticketDetails?.userId,
                u_email_id: ticketDetails?.userEmail
            })
            setSearchLeagues({
                l_id: ticketDetails?.leagueId,
                l_name: ticketDetails?.leagueName,
                l_type: ticketDetails?.leagueType 
            })
        }
    }, [page])


    return (
        <>
            <div className={styles.textFieldFullMainappversion}>
                <div>


                <div className={addTicketStyles.container}>
                <div className={styles.titlePlaceholderappversion} style = {{marginBottom: '10px'}}>
                    <b className={styles.AppOs}>Users</b>
                </div>
                <div>
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        sx={getAutocompleteStyles(false)}
                        options={listOfUsers ?? []}
                        loading={loading}
                        value={searchText}
                        onChange={handleSearchUsers}
                        onInputChange={handleInput}
                        autoHighlight
                        getOptionLabel={(option: UsersList) => option.u_email_id || "-"}
                        isOptionEqualToValue={(option: UsersList, value: UsersList) => option.u_id === value.u_id}
                        getOptionKey={(option: UsersList) => option.u_id}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select Users"
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                </div>
                    {
                        nextBtnClicked && !searchText && <span className={addTicketStyles.errorMessage}>User is required!</span>
                    }
                </div>

                <div className={addTicketStyles.container}>
                <div className={styles.titlePlaceholderappversion} style = {{marginBottom: '10px'}}>
                    <b className={styles.AppOs}>Leagues</b>
                </div>
                <div>
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        sx={getAutocompleteStyles(false)}
                        options={listOfLeagues ?? []}
                        loading={leaguesLoading}
                        value={searchLeagues}
                        onChange={handleSearchLeagues}
                        autoHighlight
                        getOptionLabel={(option: LeagueList) => option.l_name || "-"}
                        isOptionEqualToValue={(option: LeagueList, value: LeagueList) => option.l_id === value.l_id}
                        getOptionKey={(option: LeagueList) => option.l_id}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select Leagues"
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                </div>
                {
                    nextBtnClicked && !searchLeagues && <span className={addTicketStyles.errorMessage}>League is required!</span>
                }
                </div>

                <div style = {{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                    <div className={addTicketStyles.updateButtonStyle}>
                <Button
                  classes={{
                    root: styles.separateStyleReferral
                  }}
                  disableRipple
                  fullWidth
                  type="button"
                  onClick={handleUsersAndLeaguesNext}
                >
                  Next
                </Button>
              </div>
                </div>

                </div>


            </div>
        </>
    )
}

export default AddTicketsUsersAndLeagues;
